/** The colour of an active filter: the selected button's colour in `common/SegmentedButtons`, and a tint of it. */
export const ACCENT = "#6366f1";
export const ACCENT_TINT = "#eef2ff";
